/* tslint:disable */
/* eslint-disable */
/* @relayHash 1d4262159a0f02f508ad113e222aa510 */

import { ConcreteRequest } from "relay-runtime";
export type PortfolioItemsAction = "ADD" | "EDIT" | "REMOVE" | "REORDER" | "%future added value";
export type PortfolioType = "CART" | "HEART" | "%future added value";
export type ModifyPortfolioItemsInput = {
    action: PortfolioItemsAction;
    endPortfolioItemId?: string | null;
    itemsIds?: Array<string | null> | null;
    note?: string | null;
    portfolioItemsIds?: Array<string | null> | null;
    portfolioId?: string | null;
    portfolioType?: PortfolioType | null;
    startPortfolioItemId?: string | null;
    targetPortfolioItemId?: string | null;
    userId: string;
    clientMutationId?: string | null;
};
export type addCartItemMutationVariables = {
    input: ModifyPortfolioItemsInput;
};
export type addCartItemMutationResponse = {
    readonly modifyPortfolioItems: {
        readonly portfolio: {
            readonly items: {
                readonly totalResults: number | null;
            } | null;
        } | null;
    } | null;
};
export type addCartItemMutation = {
    readonly response: addCartItemMutationResponse;
    readonly variables: addCartItemMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ModifyPortfolioItemsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "items",
  "storageKey": null,
  "args": null,
  "concreteType": "PortfolioItemsConnection",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "addCartItemMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "modifyPortfolioItems",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ModifyPortfolioItemsPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "portfolio",
            "storageKey": null,
            "args": null,
            "concreteType": "PortfolioV2",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "addCartItemMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "modifyPortfolioItems",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ModifyPortfolioItemsPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "portfolio",
            "storageKey": null,
            "args": null,
            "concreteType": "PortfolioV2",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "addCartItemMutation",
    "id": "ferrum/293.0.0-2020-12-07T18:31:32.661Z/addCartItemMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '321aa184c3b379ab2a9f986679257e8d';
export default node;
